/* eslint-disable */
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'animate.css';
// import animated from 'animate.css';
import ElementUI from 'element-ui';
import '@/styles/index.scss'; // global css

import '@/icons'; // icon
import * as filters from './filters'; // global filters
import '@/components'; // global components

Vue.config.productionTip = false;
// Vue.use(animated);
Vue.use(ElementUI);

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

new Vue({
  errorCaptured(err, vm, info) {
    console.error('Error captured:', err, info);
    // 可以进行错误处理、记录错误信息等操作
    return false; // 返回 false 阻止错误继续传播
  },
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
